import { compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import { withFeatureToggles } from 'modules/shell/hoc/withFeatureToggles';
import { EXP_ASSOCIATE_SCORECARD_REDESIGN } from 'constants/featureToggleNames';
import ScorecardProgressBar from './ScorecardProgressBar';
import styles from './ScorecardProgressBar.styles';

export default compose(
  withFeatureToggles({
    expScorecardRedesignEnabled: EXP_ASSOCIATE_SCORECARD_REDESIGN,
  }),
  withStyles(styles),
)(ScorecardProgressBar);
